import React, {useState} from 'react';
import {
    Dialog,
    DialogActions,
    Button,
    DialogContent,
    DialogTitle,
    DialogContentText, 
    TextField
} from '@mui/material';

const RejectCheckDialog = ({handleStatusUpdate, openRejectDialog, setOpenRejectDialog}) => {
    const [rejectReason, setRejectReason] = useState("");
    const [showHelperText, setShowHelperText] = useState(false);

    const handleRejectMsgSubmit = async () => {
        if (rejectReason) {
            handleCloseRejectDialog();
            await handleStatusUpdate("Rejected", rejectReason);
        } else {
            setShowHelperText(true);
        }
    }

    function handleCloseRejectDialog() {
        setOpenRejectDialog(false);
    }

    return (
        <Dialog
            open={openRejectDialog}
            onClose={handleCloseRejectDialog}
            fullWidth
        >
            <DialogTitle>Reject Check</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Enter a rejection reason:
                </DialogContentText>
                <TextField
                    autoFocus
                    margin="normal"
                    id='reason'
                    label="Reject Reason"
                    type="text"
                    fullWidth
                    variant="outlined"
                    helperText={showHelperText ? "Rejection reason required" : ""}
                    error={showHelperText}
                    value={rejectReason}
                    onChange={(e) => {
                        setRejectReason(e.target.value);
                        setShowHelperText(false);
                    }}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseRejectDialog}>Cancel</Button>
                <Button onClick={handleRejectMsgSubmit} autoFocus>Submit</Button>
            </DialogActions>
        </Dialog>
    )
}

export default RejectCheckDialog;